/**
 * useReportModalStore — Zustand store for the global "Report Screen" modal.
 *
 * Replaces the CustomEvent-based pattern (gap G-N4 from CHAMADOS_VISIBILIDADE_SPEC §19.2)
 * which suffered from multiple-listener issues. Consumers (e.g. <ReportScreenButton />,
 * <ScreenErrorBoundary />) should call `useReportModalStore.getState().open()` directly
 * to trigger the modal — no events, no listeners.
 *
 * State is ephemeral (not persisted): once the modal closes, prefilledError resets.
 * See spec §9.3.4 for the FAB/modal contract.
 */

import { create } from 'zustand'

export interface ReportModalPrefilledError {
  message: string
  componentStack?: string
  errorId?: string
}

interface ReportModalState {
  opened: boolean
  prefilledError: ReportModalPrefilledError | null
  open: (prefilled?: ReportModalPrefilledError) => void
  close: () => void
}

export const useReportModalStore = create<ReportModalState>((set) => ({
  opened: false,
  prefilledError: null,
  open: (prefilled) => set({ opened: true, prefilledError: prefilled ?? null }),
  close: () => set({ opened: false, prefilledError: null }),
}))
